import { liveStats } from '@/mqtt/liveStats'
import { resourcesSubscriber } from '@/mqtt/resources'
import kvSyncSubscriber from '@/mqtt/kvSync'

function init() {
  liveStats.connect()
  resourcesSubscriber.init()
  kvSyncSubscriber.init()
}

export default { init }
